import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, switchMap } from 'rxjs/operators';

import { AppActions } from '../../../core/store/actions/app';
import { LegalDocumentService } from '../../services/LegalDocument.service';
import { LegalDocumentsActions } from '../actions/legalDocument';

@Injectable()
export class LegalDocumentsEffects {
    loadApproval$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.initialized, LegalDocumentsActions.documentsApproved),
            switchMap(() => this.legalDocumentService.getLastLegalDocumentsApproval()),
            filter((approval) => approval != null),
            map((approval) => LegalDocumentsActions.approvalLoaded(approval)),
        ),
    );

    showLegalDocumentToApprove$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.initialized),
            switchMap(() => this.legalDocumentService.getDocumentToApprove()),
            filter((documents) => documents.length > 0),
            map((documents) => LegalDocumentsActions.signingRequested({ documents })),
        ),
    );

    constructor(
        private actions$: Actions,
        private legalDocumentService: LegalDocumentService,
    ) {}
}
